import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function ViewAllCompetitorsFooter({
  visible,
  onClick,
}: {
  visible: boolean;
  onClick: () => void;
}) {
  if (!visible) return null;
  return (
    <Card.Footer className="bg-body-tertiary p-0 border-top">
      <Button
        variant="link"
        className="w-100 py-2 fs--1 text-decoration-none"
        style={{ color: 'var(--falcon-navbar-vertical-default-link-active-color)' }}
        onClick={onClick}
      >
        مشاهده همه
        <FontAwesomeIcon icon="chevron-left" className="ms-1 fs--2" />
      </Button>
    </Card.Footer>
  );
}